import { Box } from '@mui/material'
import { FrozenMovementTableProps } from './EditSettings.types'
import { GridColDef } from '@mui/x-data-grid-premium'
import { useMemo } from 'react'
import { BaseTable } from 'Features/Table/BaseTable.view'

export const FrozenMovementMUITable = ({ data }: FrozenMovementTableProps) => {
  const columns: GridColDef[] = useMemo(
    () => [
      {
        headerName: 'Dispatching site',
        field: 'dispatchSiteCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Receiving site',
        field: 'receivingSiteCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'SKU code',
        field: 'skuCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Dispatch date',
        field: 'plannedDispatchDateKeyFormatted',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Movement amount',
        field: 'plannedMovementAmount',
        flex: 1,
        type: 'number',
      },
    ],
    [data]
  )
  // No-op functions for BaseTable required props (read-only table)
  const updateTableData = () => {
    // This is a read-only table, no updates needed
  }

  const uploadData = () => {
    // No upload functionality needed
  }

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
      }}
    >
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={false}
        updateTableData={updateTableData}
        uploadData={uploadData}
        isUploading={false}
        isSaving={false}
        checkBoxSelection={false}
        showTableToolBar={false}
        pinnedColumns={['dispatchSiteCode', 'receivingSiteCode']}
        downloadFileName="FrozenMovement"
      />
    </Box>
  )
}
